import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ARTICLES } from "@/data/insights";
import { useTitle } from "@/lib/useTitle";

const Insights = () => {
  useTitle("Insights | Rice & Agro Commodity Export Guides — GN Agro Traders",
    "Practical guides for international rice importers: Basmati varieties, Raw vs Steam vs Sella processing, supplier evaluation and bulk procurement basics.");

  return (
    <div>
      <section className="bg-[#004225] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-[11px] font-eyebrow text-[#D4AF37]"><span className="gold-line mr-3" />Insights</div>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl">Guides for International Buyers</h1>
          <p className="mt-3 max-w-2xl text-white/80">Practical, specification-led reading for importers, distributors and procurement teams sourcing rice, pulses and agro commodities from India.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-2 gap-6" data-testid="insights-grid">
          {ARTICLES.map((a) => (
            <Link key={a.slug} to={`/insights/${a.slug}`} data-testid={`article-${a.slug}`}
              className="bg-white border border-[#004225]/10 rounded-sm p-7 card-elevate flex flex-col">
              <div className="text-[10px] font-eyebrow text-[#B5942D]">{a.date} · {a.readTime} read</div>
              <h2 className="mt-2 font-display text-2xl text-[#004225] leading-snug">{a.title}</h2>
              <p className="mt-3 text-[14px] text-[#171717]/75 leading-relaxed flex-1">{a.excerpt}</p>
              <div className="mt-4 text-[11px] font-semibold uppercase tracking-widest text-[#004225] inline-flex items-center gap-1.5">Read guide <ArrowRight className="h-3.5 w-3.5" /></div>
            </Link>
          ))}
        </div>
        <div className="mt-12 bg-[#004225] text-white rounded-sm p-8 sm:p-10">
          <h3 className="font-display text-2xl sm:text-3xl">Have a requirement in mind?</h3>
          <p className="mt-2 text-white/80 text-[14px] max-w-xl">Share your variety, specification, quantity and destination — our export team will respond with availability and a commercial proposal.</p>
          <div className="mt-5 flex flex-wrap gap-3">
            <Link to="/request-quote" className="rounded-full btn-gold px-6 py-3 text-[11px] font-semibold uppercase tracking-widest">Request Bulk Quotation</Link>
            <Link to="/products" className="rounded-full border border-white/30 text-white px-6 py-3 text-[11px] font-semibold uppercase tracking-widest hover:bg-white/10">Explore Products</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Insights;
